import { render, staticRenderFns } from "./RowProposal.vue?vue&type=template&id=4d678e1c"
import script from "./RowProposal.vue?vue&type=script&lang=js"
export * from "./RowProposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports